import { render, staticRenderFns } from "./EmptyStateButton.vue?vue&type=template&id=f2a18b16"
import script from "./EmptyStateButton.vue?vue&type=script&lang=js"
export * from "./EmptyStateButton.vue?vue&type=script&lang=js"
import style0 from "./EmptyStateButton.vue?vue&type=style&index=0&id=f2a18b16&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports